import React from 'react';

// Pricing page component
const PricingPage = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <h1 className="privacy-title">Pricing & Credits</h1>

        <div className="privacy-content">
          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">1</span>
              <h2>Free Credits for New Users</h2>
            </div>
            <p>
              When you sign up for getphotoshoot.ai, you'll receive <strong>10 free credits</strong> worth <strong>₹250</strong> to get started immediately. Use these credits to explore our platform and generate professional jewelry images without any upfront cost.
            </p>
            <ul className="terms-list">
              <li>10 credits included with every new account</li>
              <li>Worth ₹250 in value</li>
              <li>No credit card required for sign-up</li>
              <li>Start generating images right away</li>
            </ul>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">2</span>
              <h2>Credit-Based Pricing</h2>
            </div>
            <p>
              getphotoshoot.ai uses a simple, transparent credit-based system. You only pay for what you use, with no monthly subscriptions or hidden fees.
            </p>
            
            <div style={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>
              <h3 style={{ marginBottom: '0.75rem', fontSize: '1.1rem', fontWeight: '600' }}>Credit Costs:</h3>
              <ul className="terms-list">
                <li><strong>AI Model Image Generation:</strong> 2 credits per image</li>
                <li><strong>Real Human Model Image Generation:</strong> 4 credits per merge</li>
              </ul>
            </div>

            <p>
              Each credit represents a fixed value, making it easy to budget and plan your photography needs. Generate as many images as you need, when you need them.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">3</span>
              <h2>Credit Packages</h2>
            </div>
            <p>
              Purchase credits in bulk to save more. All credit packages come with the same per-credit value - buy more, save more!
            </p>

            <div className="pricing-cards-grid">
              <div className="pricing-card">
                <h3 style={{ marginBottom: '0.5rem', fontSize: '1.25rem', fontWeight: '600' }}>Starter Pack</h3>
                <div style={{ fontSize: '2rem', fontWeight: '700', color: '#1e40af', marginBottom: '0.5rem' }}>100 Credits</div>
                <div style={{ fontSize: '1.1rem', color: '#64748b', marginBottom: '1rem' }}>₹5,000</div>
                <ul style={{ listStyle: 'none', padding: 0, marginBottom: '1rem', fontSize: '0.9rem' }}>
                  <li style={{ marginBottom: '0.5rem' }}>✓ 50 image generations</li>
                  <li style={{ marginBottom: '0.5rem' }}>✓ 25 merge operations</li>
                  <li style={{ marginBottom: '0.5rem' }}>✓ Perfect for testing</li>
                </ul>
              </div>

              <div className="pricing-card pricing-card-popular">
                <div className="pricing-badge">POPULAR</div>
                <h3 style={{ marginBottom: '0.5rem', fontSize: '1.25rem', fontWeight: '600' }}>Business Pack</h3>
                <div style={{ fontSize: '2rem', fontWeight: '700', color: '#1e40af', marginBottom: '0.5rem' }}>500 Credits</div>
                <div style={{ fontSize: '1.1rem', color: '#64748b', marginBottom: '1rem' }}>₹22,500 <span style={{ fontSize: '0.9rem', color: '#10b981' }}>(Save ₹2,500)</span></div>
                <ul style={{ listStyle: 'none', padding: 0, marginBottom: '1rem', fontSize: '0.9rem' }}>
                  <li style={{ marginBottom: '0.5rem' }}>✓ 250 image generations</li>
                  <li style={{ marginBottom: '0.5rem' }}>✓ 125 merge operations</li>
                  <li style={{ marginBottom: '0.5rem' }}>✓ Best value for small businesses</li>
                </ul>
              </div>

              <div className="pricing-card">
                <h3 style={{ marginBottom: '0.5rem', fontSize: '1.25rem', fontWeight: '600' }}>Professional Pack</h3>
                <div style={{ fontSize: '2rem', fontWeight: '700', color: '#1e40af', marginBottom: '0.5rem' }}>1,000 Credits</div>
                <div style={{ fontSize: '1.1rem', color: '#64748b', marginBottom: '1rem' }}>₹40,000 <span style={{ fontSize: '0.9rem', color: '#10b981' }}>(Save ₹10,000)</span></div>
                <ul style={{ listStyle: 'none', padding: 0, marginBottom: '1rem', fontSize: '0.9rem' }}>
                  <li style={{ marginBottom: '0.5rem' }}>✓ 500 image generations</li>
                  <li style={{ marginBottom: '0.5rem' }}>✓ 250 merge operations</li>
                  <li style={{ marginBottom: '0.5rem' }}>✓ Ideal for established retailers</li>
                </ul>
              </div>
            </div>

            <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: '#64748b' }}>
              <strong>Note:</strong> Credit pricing may vary based on promotional offers. Current prices are subject to change. Contact us for enterprise pricing and custom packages.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">4</span>
              <h2>How Credits Work</h2>
            </div>
            <p>Understanding our credit system is simple:</p>
            <ul className="terms-list">
              <li><strong>Purchase credits:</strong> Buy credits in packages that suit your needs</li>
              <li><strong>Use credits:</strong> Credits are automatically deducted when you generate or merge images</li>
              <li><strong>Track usage:</strong> Monitor your remaining credits in your dashboard</li>
              <li><strong>No expiration:</strong> Credits never expire (subject to terms of service)</li>
              <li><strong>Flexible usage:</strong> Use credits for any combination of generations and merges</li>
            </ul>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">5</span>
              <h2>Payment Methods</h2>
            </div>
            <p>We accept various payment methods for your convenience:</p>
            <ul className="terms-list">
              <li>Credit and Debit Cards (Visa, Mastercard, American Express)</li>
              <li>UPI (Unified Payments Interface)</li>
              <li>Net Banking</li>
              <li>Digital Wallets</li>
              <li>Bank Transfers (for enterprise customers)</li>
            </ul>
            <p>
              All payments are processed securely through our payment gateway partners. Your payment information is encrypted and never stored on our servers.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">6</span>
              <h2>Refund Policy</h2>
            </div>
            <p>
              Unused credits may be eligible for refund under certain circumstances. For detailed information about our refund policy, please see our <a className="terms-link" href="/refunds">Refund Policy</a> page.
            </p>
            <p>
              In most cases, we prefer to resolve issues by adding credits to your account or reprocessing requests at no additional cost.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">7</span>
              <h2>Enterprise Pricing</h2>
            </div>
            <p>
              Need a custom solution for your business? We offer tailored pricing packages for:
            </p>
            <ul className="terms-list">
              <li>High-volume users (10,000+ credits)</li>
              <li>Enterprise customers with specific requirements</li>
              <li>White-label solutions</li>
              <li>API access and integrations</li>
              <li>Dedicated support and SLAs</li>
            </ul>
            <p>
              Contact our sales team at <a className="terms-link" href="mailto:partners@getphotoshoot.ai">partners@getphotoshoot.ai</a> to discuss your needs and get a custom quote.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">8</span>
              <h2>Frequently Asked Questions</h2>
            </div>
            
            <h3 style={{ marginTop: '1rem', marginBottom: '0.5rem', fontSize: '1rem', fontWeight: '600' }}>Do credits expire?</h3>
            <p style={{ marginBottom: '1rem' }}>
              No, credits do not expire. Once purchased, you can use them whenever you need, as long as your account remains active and in good standing.
            </p>

            <h3 style={{ marginTop: '1rem', marginBottom: '0.5rem', fontSize: '1rem', fontWeight: '600' }}>Can I get a refund for unused credits?</h3>
            <p style={{ marginBottom: '1rem' }}>
              Refund eligibility depends on specific circumstances. Please refer to our <a className="terms-link" href="/refunds">Refund Policy</a> or contact support for assistance.
            </p>

            <h3 style={{ marginTop: '1rem', marginBottom: '0.5rem', fontSize: '1rem', fontWeight: '600' }}>What if I run out of credits mid-project?</h3>
            <p style={{ marginBottom: '1rem' }}>
              You can purchase additional credits at any time. Simply select a credit package and complete the payment to instantly add credits to your account.
            </p>

            <h3 style={{ marginTop: '1rem', marginBottom: '0.5rem', fontSize: '1rem', fontWeight: '600' }}>Are there any discounts available?</h3>
            <p style={{ marginBottom: '1rem' }}>
              Yes! Buying larger credit packages gives you better value per credit. We also run promotional offers from time to time. Follow our updates or contact sales for current discounts.
            </p>
          </section>

          <section className="terms-section">
            <div className="terms-section-header">
              <span className="terms-section-number">9</span>
              <h2>Get Started</h2>
            </div>
            <p>
              Ready to transform your jewelry photography? Sign up now and get your <strong>10 free credits</strong> (worth ₹250) to start generating professional images immediately.
            </p>
            <p>
              Have questions about pricing? Our team is here to help. Contact us at <a className="terms-link" href="mailto:success@getphotoshoot.ai">success@getphotoshoot.ai</a> or visit our <a className="terms-link" href="/contact">Contact Information</a> page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;

